import { Component, OnInit } from '@angular/core';
import { CampaignService, SidebarWrapperService } from '@services/index';
import { Observable, Subject } from 'rxjs';
import { takeUntil, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { isArray } from 'util';
import * as moment from "moment";
import { Router } from '@angular/router';

@Component({
  selector: 'app-joined-campaigns',
  templateUrl: './joined-campaigns.component.html',
  styleUrls: ['./joined-campaigns.component.scss']
})
export class JoinedCampaignsComponent implements OnInit {
  involvedCampaigns$: Observable<any>;
  involvedCampaigns: any[] = [];
  private unsubscribe$ = new Subject<void>();
  campaignStatuses = {
    1: "Active",
    0: "Paused",
    "-1": "Stopped",
  };

  constructor(
    private campaignService: CampaignService, 
    private router: Router,
    private sidebarWrapperService: SidebarWrapperService
    ) { 
    this.involvedCampaigns$ = this.campaignService.getInvolvedCampaignsSelector();
    this.campaignService.fetchInvolvedCampaigns();
  }

  ngOnInit() {
    this.involvedCampaigns$.pipe(takeUntil(this.unsubscribe$))
      .subscribe(campaigns => {
        if(!isArray(campaigns)){return}
        this.involvedCampaigns = campaigns;
      });
  }

  getCommissions(type, commission): string {
    if (!commission) {
      return "-";
    }

    if (type === "lead") {
      return commission.lead_commission
        ? "$" + commission.lead_commission
        : "-";
    }

    if (type === "sale") {
      return commission.sale_auto_currency === "percent" &&
        commission.sale_commission
        ? commission.sale_commission + "%"
        : commission.sale_auto_currency === "money" &&
          commission.sale_commission
        ? "$" + commission.sale_commission
        : "-";
    }
  }

  getDate(startDate, endDate): string {
    if (!startDate && !endDate) return "-";
    let start = moment(startDate).format("D MMM");
    let end = moment(endDate).format("D MMM");
    return start + " - " + end;
  }

  goToCampaigns(){
    this.router.navigate(['promotions', 'campaigns']);
    this.sidebarWrapperService.closeSidebar()
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
